<template>
  <div role="button" :class="getButtonClass" @click="buttonClickEvent">
    <div class="button__border">
      <component :is="decorLeft" />
      <div key="button__content" class="button__content">
        <slot />
        <span v-if="!!icon" :class="`button__icon--${icon}`">
          <icon :name="icon"></icon>
        </span>
      </div>
      <component :is="decorRight" />
    </div>
  </div>
</template>

<script>
import MainButtonDecorLeft from "@static_promo_pages/common/components/redesign/main-button/vue/MainButtonDecorLeft.vue";
import MainButtonDecorLeftMedium from "@static_promo_pages/common/components/redesign/main-button/vue/MainButtonDecorLeftMedium.vue";
import MainButtonDecorLeftSmall from "@static_promo_pages/common/components/redesign/main-button/vue/MainButtonDecorLeftSmall.vue";
import MainButtonDecorRight from "@static_promo_pages/common/components/redesign/main-button/vue/MainButtonDecorRight.vue";
import MainButtonDecorRightSmall from "@static_promo_pages/common/components/redesign/main-button/vue/MainButtonDecorRightSmall.vue";
import MainButtonDecorRightMedium from "@static_promo_pages/common/components/redesign/main-button/vue/MainButtonDecorRightMedium.vue";

import MobileDetectionMixin from "@godweb/frontend-base/src/mixins/mobile_detection/MobileDetectionMixinNew";

export default {
  name: "MainButton",
  components: {
    MainButtonDecorLeft,
    MainButtonDecorLeftMedium,
    MainButtonDecorLeftSmall,
    MainButtonDecorRight,
    MainButtonDecorRightSmall,
    MainButtonDecorRightMedium,
  },
  mixins: [MobileDetectionMixin],
  props: {
    theme: {
      type: String,
      default: "default", // default, cta
    },
    size: {
      type: String,
      default: "medium", // medium, small, mobile-small, mobile-extra-small
    },
    icon: {
      type: String,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },

  },
  computed: {
    getButtonClass() {
      return [
        "button",
        `button--${this.theme}`,
        `button--${this.size}`,
        {
          "button--disabled": this.isDisabled,
        },
      ];
    },
    decorLeft() {
      if ((this.size === "small" || this.size === "mobile-small" || this.size === "mobile-extra-small") && this.isLaptopSmallMax) {
        return MainButtonDecorLeftSmall
      }
      if (this.size === "mobile-extra-small" && this.isLaptopSmall) {
        return MainButtonDecorLeftMedium
      }
      return MainButtonDecorLeft
    },
    decorRight() {
      if ((this.size === "small" || this.size === "mobile-small" || this.size === "mobile-extra-small") && this.isLaptopSmallMax) {
        return MainButtonDecorRightSmall
      }
      if (this.size === "mobile-extra-small" && this.isLaptopSmall) {
        return MainButtonDecorRightMedium
      }
      return MainButtonDecorRight
    },
  },

  methods: {
    buttonClickEvent(event) {
      if (!this.isDisabled && !this.isDisabledWithoutOpacity) {
        this.$emit("click", event);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../styles";
</style>
